import type { SolutionSector } from "../sectors";
import { ASK_LINE, LOGO } from "./shared";

export const FOOD_CONSUMER_GOODS: SolutionSector = {
  slug: "fmcg",
  name: "Food & consumer goods",
  demoOrg: "Demo (FMCG)",
  story: "food",
  metadata: {
    title: "AI for product launch reviews | Your Twin",
    description:
      "See missing supplier documents and open questions before each launch review. Your Twin connects Google Sheets, Google Drive, Xero and Outlook.",
  },
  hero: {
    label: "Food & consumer goods",
    title: ["Know what’s", "missing before", "the launch."],
    lead: [
      "Spend less time chasing launch documents. Your Twin connects launch trackers in ",
      LOGO.sheets,
      " with specifications in ",
      LOGO.drive,
      ", supplier bills in ",
      LOGO.xero,
      " and updates in ",
      LOGO.outlook,
      ", so you can see missing documents, open supplier questions and owners before the launch review.",
    ],
    cta: "Bring a launch checklist",
    buyer: "For operations, commercial and supply chain directors",
    instrumentLabel: "The launch Twin · Product, document, supplier and owner",
    legendLines: [
      "Read Google Sheets, Google Drive, Xero and Outlook.",
      "Link each product to its specifications, supplier documents and bills.",
      "Build one picture of each product before launch.",
      "Check the connections and documents against your source records.",
      "Have agents prepare launch reviews and flag missing documents.",
      "Save their work in shared channels: launch checklists and review tables.",
      ASK_LINE,
    ],
  },
  replay: {
    title: "What’s still missing\nfor next month’s launch?",
    lead: "Ask across the launch plan, the documents and the supplier replies. See each outstanding item beside its launch date and owner.",
  },
  outcomes: {
    title: "Every launch document\nin view.",
    lead: "The launch team sees what each supplier still owes and who is chasing it.",
    items: [
      { title: "Find the missing launch document.", body: "Compare the checklist with the connected supplier records.", show: "status" },
      { title: "Keep specifications in view.", body: "See which revision the review is using.", show: "sources" },
      { title: "Prepare the supplier follow-up.", body: "Bring the open question and recorded owner together.", show: "owners" },
    ],
  },
  start: { firstStep: "Choose a launch checklist your team keeps chasing." },
  questions: [
    { q: "Does it replace our ERP or stock system?", a: "No. This workflow uses launch documents and supplier records; it doesn’t replace your ERP or stock system." },
    { q: "Can it forecast demand or prevent stockouts?", a: "No. This workflow does neither." },
    { q: "Does it certify quality or food safety?", a: "No. It organises the evidence for review. Qualified people make those decisions." },
  ],
  closing: "Start with one launch checklist\nyour team keeps chasing.",
};
